export var SHOW_STATUS = {
  NORMAL: 0,
  // 正常
  SOLD_OUT: 1,
  // 售罄
  STOCK_OUT: 2,
  // 缺货登记
  TO_SALE: 3,
  // 即将开售
  DELAY: 4,
  // 延期
  CANCEL: 5 // 取消
};